module.exports = __webpack_public_path__ + "assets/img/title.cff7b41a.png";